import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { ModalDirective } from 'angular-bootstrap-md';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Family } from 'src/app/models/Family';
import { ReportOrder } from 'src/app/models/ReportOrder';
import { ResponseReportOrder } from 'src/app/models/ResponseReportOrder';
import { ResponseReportOrderDetail } from 'src/app/models/ResponseReportOrderDetail';
import { SearchReport } from 'src/app/models/SearchReport';
import { TableReportOrderCustom } from 'src/app/models/TableReportOrderCustom';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { FamilyService } from 'src/app/services/family.service';
import { OrderService } from 'src/app/services/order.service';
import { PermissionService } from 'src/app/services/permission.service';
import { ReportService } from 'src/app/services/report.service';
import { CONSTANTES, getToken } from 'src/app/shared/global';

declare var jQuery: any;

@Component({
  selector: 'app-orders-report',
  templateUrl: './orders-report.component.html',
  styleUrls: ['./orders-report.component.scss']
})
export class OrdersReportComponent implements OnInit {

  @ViewChild('infoModal') infoModal: ModalDirective;
  @ViewChild('clear') clear;

  titles: String[] = ['FECHA VENTA', 'FAMILIA', 'SUBFAMILIA', 'NOC', 'ARTÍCULO', 'TALLA', 'CANTIDAD', 'IMPORTE'];

  public families: Family[] = [];
  public subFamilies: Family[] = [];
  public familySelect: string;
  public subFamilySelect: string;
  public subFamiliesSelect: String[] = [];
  public period: Date;
  public form: FormGroup;
  public dateFromSelect: Date;
  public dateToSelect: Date;
  public search: boolean = false;
  public displayedColumns: string[] = ['orderNumber', 'dateOrder', 'datePreparation', 'dateShipment',  'status'];
  public displayedDetailColumns: string[] = ['clothes', 'noc', 'size', 'amount', 'prices'];
  public displayedCustomColumns: string[] = ['orderNumber', 'dateOrder', 'datePreparation', 'dateShipment', 'status', 'noc', 'amount', 'prices'];
  public statusSelect: string;
  public statusList: String[] = [];
  keyword = 'name';
  public total: number=0;
  public totalPrice: number=0;
  public searchDetail: boolean = false;
  
  public dataSourceCustom: TableReportOrderCustom[];
  //public dataSourceCustomTotal: MatTableDataSource<TableReportOrderCustom>;

  public data: ResponseReportOrder[];
  public dataSourceDetail: ResponseReportOrderDetail[] = [];
  public dataSourceDetailTotal: MatTableDataSource<ResponseReportOrderDetail>;

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatSort) sortDetail: MatSort;

  public dataTotal : MatTableDataSource<ResponseReportOrder>;
  public dataSource : ResponseReportOrder[];

  constructor(private reportService: ReportService, private spinner: NgxSpinnerService, private toastr: ToastrService, private orderService: OrderService,
    private authService: AuthenticationService, private router: Router, private familyService: FamilyService, private permissionService: PermissionService) { }

  ngOnInit() {
    this.spinner.show();
    try {
      jQuery.getScript(CONSTANTES.menu);
    } catch (Error) {
      this.router.navigate(['login']);
    }

    this.loadFamilies();
    this.loadStatus();
    //this.loadUsers();
    this.form = new FormGroup({
      'family': new FormControl('', Validators.required),
      'subFamily': new FormControl('', Validators.required),
      'status': new FormControl('', Validators.required),
      'dateFrom': new FormControl('', Validators.required),
      'dateTo': new FormControl('', Validators.required),
    });

  }

  /**Obtiene todos los usuarios para ser mostrados en el autocompletable
  loadUsers(){
    this.permissionService.getAllUserWhitOrdersFinished().subscribe(
      data => {
        if (getToken(data)) {
          if(data.users != null && data.users.length>0){
            for (let i = 0; i < data.users.length; i++) {
                this.usersList.push(data.users[i]);
            }
          }else{
            this.toastr.error("HA OCURRIDO UN ERROR AL CARGAR LOS DATOS DE USUARIOS", "ERROR");
          }
        }
      },
      error => {
        this.spinner.hide();
        this.toastr.error("HA OCURRIDO UN ERROR AL CARGAR LOS DATOS DE USUARIOS", "ERROR");
      }  
    )
  } */

  /**Obtiene las familias */
  loadFamilies() {
    this.spinner.show();
    this.familyService.getAll().subscribe(
      data => {
        if (getToken(data)) {
          for (let i = 0; i < data.families.length; i++) {
            if (data.families[i].parent === null) {
              this.families.push(data.families[i]);
            } else {
              this.subFamilies.push(data.families[i]);
            }
          }
        }
      },
      error => {
        this.spinner.hide();
        this.toastr.error("HA OCURRIDO UN ERROR AL CARGAR LOS DATOS", "ERROR");
      }
    )
    this.spinner.hide();
  }

  /**Obtiene los estados */
  loadStatus() {
    this.spinner.show();
    this.statusList.push("FINALIZADO");
    this.statusList.push("CANCELADO");
    this.statusList.push("CONFIRMADO");
    this.statusList.push("AUTORIZANDO");
    this.spinner.hide();
  }

  /**Obtiene las subfamilias de la familia seleccionada */
  getSubfamilies() {
    this.spinner.show();
    this.subFamiliesSelect = [];
    this.subFamiliesSelect.push('');
    for (let i = 0; i < this.subFamilies.length; i++) {
      if (this.subFamilies[i].parent.name === this.familySelect) {
        this.subFamiliesSelect.push(this.subFamilies[i].name);
      }
    }
    this.spinner.hide();
  }

  loadReport() {
    let reportOrder = new ReportOrder();
    reportOrder.searchReport = new SearchReport();

    if (this.familySelect != null && this.familySelect.length > 0) {
      reportOrder.searchReport.family = this.familySelect.toString();
    } else {
      reportOrder.searchReport.family = null;
    }

    if (this.subFamilySelect != null && this.subFamilySelect.length > 0) {
      reportOrder.searchReport.subFamily = this.subFamilySelect.toString();
    } else {
      reportOrder.searchReport.subFamily = null;
    }

    /*if(this.selectUser != null && this.selectUser.length>0){
      reportOrder.searchReport.nid = this.selectUser.toString();
    }else{
      reportOrder.searchReport.nid = null;
    }*/

    if (this.statusSelect === 'FINALIZADO') {
      this.statusSelect = 'FINISHED'
    }
    else if (this.statusSelect === 'CANCELADO') {
      this.statusSelect = 'CANCELLED'
    }
    else if (this.statusSelect === 'CONFIRMADO') {
      this.statusSelect = 'CONFIRMED'
    }
    else if (this.statusSelect === 'AUTORIZANDO') {
      this.statusSelect = 'SAVED'
    }

    if (this.statusSelect != null && this.statusSelect.length > 0) {
      reportOrder.searchReport.status = this.statusSelect.toString();
    } else {
      reportOrder.searchReport.status = null;
    }

    if (this.dateFromSelect != null && this.dateToSelect != null) {
      reportOrder.searchReport.toDate = this.dateToSelect;
      reportOrder.searchReport.fromDate = this.dateFromSelect;
    } else {
      reportOrder.searchReport.toDate = null;
      reportOrder.searchReport.fromDate = null;
    }

    if ((this.dateFromSelect != null && this.dateToSelect != null) && (this.dateFromSelect == this.dateToSelect)) {
      this.toastr.info("NO PUEDEN COINCIDIR LAS FECHAS");
    }
    else if (this.dateFromSelect > this.dateToSelect) {
      this.toastr.info("LA FECHA DE FIN NO PUEDE SER ANTERIOR A LA INCIO");
    }
    else if ((this.dateToSelect == null && this.dateFromSelect != null) || (this.dateToSelect != null && this.dateFromSelect == null)) {
      this.toastr.info("DEBE RELLENAR EL PERIODO DE MANERA COMPLETA");
    } else {
      reportOrder.responseReportOrder = [];
      reportOrder.responseReportSales = [];
      reportOrder.responseReportStore = [];
      this.search = false;

      this.spinner.show();
      this.reportService.getReportOrder(reportOrder).subscribe(
        data => {
          if (getToken(data)) {
            if (data.responseReportOrder === null || data.responseReportOrder.length === 0) {
              this.search = false;
              this.toastr.info("NO EXISTEN DATOS PARA MOSTRAR", "INFO");
            } else {
              this.search = true;
              this.dataSource = data.responseReportOrder;
              this.dataTotal = new MatTableDataSource(data.responseReportOrder);
              this.dataTotal.sort = this.sort;
              this.total = this.dataSource.length;

              for (let i = 0; i < this.dataSource.length; i++) {
                if (this.dataSource[i].status === 'FINISHED') {
                  this.dataSource[i].status = 'FINALIZADO'
                }
                else if (this.dataSource[i].status === 'CANCELLED') {
                  this.dataSource[i].status = 'CANCELADO'
                }
                else if (this.dataSource[i].status === 'CONFIRMED') {
                  this.dataSource[i].status = 'CONFIRMADO'
                }
                else if (this.dataSource[i].status === 'SAVED') {
                  this.dataSource[i].status = 'AUTORIZANDO'
                }
              }

              this.data = data.responseReportOrder;
              
            }

          }
          this.spinner.hide();
        }, error => {
          this.toastr.error(error);
          this.spinner.hide();
          this.logOut();
        }
      );
      this.spinner.hide();
    }
  }

  logOut() {
    let infoUser = {
      userName: localStorage.getItem("nid")
    }
    this.authService.logOut(infoUser).subscribe(
      data => {
        localStorage.clear();
        this.router.navigate(['login']);
      }
    );
  }

  detailOrder(i: number) {
    this.dataSourceDetail = [];
    this.dataSourceDetail = this.data[i].detail;
    this.dataSourceDetailTotal = new MatTableDataSource(this.data[i].detail);
    this.dataSourceDetailTotal.sort = this.sortDetail; 
    this.searchDetail = true;
    this.infoModal.show();
  }

  /**Método que se encarga de cerrar y liberar la memoria del modal*/
  closeModal() {
    this.searchDetail = false;
    this.infoModal.hide();
    this.infoModal.ngOnDestroy();
  }

  /**Permite obtener el individuo*/
  selectEvent(item) {
    // do something with selected item
    //this.selectUser = item;
  }

  onChangeSearch(val: string) {
    // fetch remote data from here
    // And reassign the 'data' which is binded to 'data' property.
    //this.selectUser = val;
  }

  onFocused(e) {
    // do something when input is focused
    this.clear.clear();
    //this.selectUser = " ";
  }

  async tableCustom() {
    this.dataSourceCustom = [];
    for (let i = 0; i < this.dataSource.length; i++) {
      let detail = this.dataSource[i].detail;
      if (detail.length > 0) {
        if (detail.length > 1) {
          for (let j = 0; j < detail.length; j++) {
            let aux = new TableReportOrderCustom;
            aux.orderNumber = this.dataSource[i].orderNumber;
            aux.dateOrder = this.dataSource[i].dateOrder;
            aux.datePreparation = this.dataSource[i].datePreparation;
            aux.dateShipment = this.dataSource[i].dateShipment;
            aux.status = this.dataSource[i].status;
            aux.amount = detail[j].amount;
            aux.noc = detail[j].noc;
            aux.prices = detail[j].prices;
            this.dataSourceCustom.push(aux);
          }
        }
        else {
          let aux = new TableReportOrderCustom();
          aux.orderNumber = this.dataSource[i].orderNumber;
          aux.dateOrder = this.dataSource[i].dateOrder;
          aux.datePreparation = this.dataSource[i].datePreparation;
          aux.dateShipment = this.dataSource[i].dateShipment;
          aux.status = this.dataSource[i].status;
          aux.amount = detail[0].amount;
          aux.noc = detail[0].noc;
          aux.prices = detail[0].prices;
          this.dataSourceCustom.push(aux);
        }
      }


    }
    this.spinner.show();
    let content2: HTMLElement = document.getElementById('myButton') as HTMLElement
    await new Promise(resolve => setTimeout(resolve, 5000)).then(()=> {
      content2.click()
      this.spinner.hide()
    }
    );
    
  }

  getTotalCost() {
    return this.total;
  }

  getTotalCostDetail() {
    this.totalPrice = 0;
    this.dataSourceDetail.forEach(element => {
      this.totalPrice += element.prices;
    });
    return this.totalPrice;
  }

}
